import moment from "moment-timezone";

import { DateTimeRangeFilterValue } from "./FilterBarDateTimeRangeTypes";

export const FILTER_VALUE_DATE_FORMAT = "YYYY-MM-DD";

export function dateTimeRangeTSTFilterFn(
    filterValue: DateTimeRangeFilterValue,
    dateStr: string | null
) {
    if (!filterValue) {
        return true;
    }
    if (!dateStr) {
        // No date set → the row can never fall inside an active range.
        return false;
    }
    const date = moment(dateStr, moment.ISO_8601);
    if (!date.isValid()) {
        return false;
    }
    // Match by local calendar day, like the picker bounds.
    const day = date.format(FILTER_VALUE_DATE_FORMAT);
    const [start, end] = filterValue;
    return (start === null || day >= start) && (end === null || day <= end);
}
